import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TSupportedPostalOperatorsApi } from './types';

export const supportedPostalOperators: TSupportedPostalOperatorsApi = {
	getList: (payload) =>
		http.post(endpoint.supportedPostalOperators.LIST, payload).then((response) => response.data),
	getDetails: (payload) =>
		http
			.get(endpoint.supportedPostalOperators.DETAILS(payload.id))
			.then((response) => response.data),
	create: (payload) =>
		http.post(endpoint.supportedPostalOperators.CREATE, payload).then((response) => response.data),
	update: (payload) =>
		http
			.put(endpoint.supportedPostalOperators.UPDATE(payload.id), payload.body)
			.then((response) => response.data),
	remove: (payload) =>
		http
			.delete(endpoint.supportedPostalOperators.DELETE(payload.id))
			.then((response) => response.data),
};
